/**
 * js considers arrays and null to be objects
 */
export const isTrueObject = (object: unknown): object is Record<string | symbol, unknown> =>
  typeof object === 'object' && object != null && !Array.isArray(object);
